"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsExport = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ExportFormats = require("../../constants/ExportFormats");
var _DmsFetch = require("../DmsFetch/DmsFetch");
var _DmsButton = require("../DmsButton/DmsButton");
var _DmsButtonGroup = require("../DmsButtonGroup/DmsButtonGroup");
var _DmsDropdown = require("../DmsDropdown/DmsDropdown");
var _DmsTokenHook = require("../DmsTokenHook/DmsTokenHook");
var _Download = _interopRequireDefault(require("@mui/icons-material/Download"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const DmsExport = props => {
  let {
    url,
    variant,
    needs_authentication,
    formats,
    group,
    title,
    table,
    hidePdf,
    hideCsv,
    hideExcel,
    hideFormats
  } = props;
  variant = variant || 'dark';
  needs_authentication = needs_authentication || false;
  formats = formats || [_ExportFormats.EXPORT_FORMATS.EXCEL, _ExportFormats.EXPORT_FORMATS.PDF, _ExportFormats.EXPORT_FORMATS.CSV];
  group = group || true;
  title = title || /*#__PURE__*/_react.default.createElement(_material.Tooltip, {
    title: _reactIntlUniversal.default.get("ExportData").d("Export Data")
  }, /*#__PURE__*/_react.default.createElement(_Download.default, null));
  table = table || null;
  hideFormats = hideFormats || [];

  // Filter formats based on hide props
  if (hidePdf) {
    formats = formats.filter(format => format !== _ExportFormats.EXPORT_FORMATS.PDF);
  }
  if (hideCsv) {
    formats = formats.filter(format => format !== _ExportFormats.EXPORT_FORMATS.CSV);
  }
  if (hideExcel) {
    formats = formats.filter(format => format !== _ExportFormats.EXPORT_FORMATS.EXCEL);
  }
  // Filter by hideFormats array (more flexible approach)
  if (hideFormats.length > 0) {
    formats = formats.filter(format => !hideFormats.includes(format));
  }

  // If all formats are hidden, don't render anything
  if (formats.length === 0) {
    return null;
  }
  const token = (0, _DmsTokenHook.getToken)();
  const exportTable = format => {
    if (table && table.current) {
      url = table.current.exportUrl;
      needs_authentication = table.current.needs_authentication;
    }
    if (!url) {
      console.error('Export URL is not defined');
      return;
    }
    let endpoint = "";
    if (url.includes('?')) {
      let splitURL = url.split('?');
      endpoint = splitURL.shift() + '?format=' + format + '&' + splitURL.join('&');
    } else {
      endpoint = url + '?format=' + format;
    }
    (0, _DmsFetch.downloadUrl)(endpoint, needs_authentication ? token : null);
  };
  const getName = item => {
    return _ExportFormats.EXPORT_FORMATS_NAMES[item] || item;
  };
  const getFormat = name => {
    return _ExportFormats.EXPORT_FORMATS[name] || name;
  };
  return group ? /*#__PURE__*/_react.default.createElement(_DmsDropdown.DmsDropdown, {
    title: title,
    variant: variant,
    items: formats.map(item => getName(item)),
    button: true,
    onSelect: name => exportTable(getFormat(name))
  }) : /*#__PURE__*/_react.default.createElement(_DmsButtonGroup.DmsButtonGroup, null, formats.map(item => {
    return /*#__PURE__*/_react.default.createElement(_DmsButton.DmsButton, {
      key: item,
      variant: variant,
      text: getName(item),
      onClick: () => exportTable(item)
    });
  }));
};
exports.DmsExport = DmsExport;
DmsExport.propTypes = {
  /** API endpoint URL for export */
  url: _propTypes.default.string,
  /** Button variant style */
  variant: _propTypes.default.string,
  /** Whether authentication is required */
  needs_authentication: _propTypes.default.bool,
  /** Array of export formats to display */
  formats: _propTypes.default.arrayOf(_propTypes.default.string),
  /** Group formats in dropdown (true) or show as separate buttons (false) */
  group: _propTypes.default.bool,
  /** Custom title/icon for export button */
  title: _propTypes.default.node,
  /** Reference to DmsTable component */
  table: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
    current: _propTypes.default.any
  })]),
  /** Hide PDF export option */
  hidePdf: _propTypes.default.bool,
  /** Hide CSV export option */
  hideCsv: _propTypes.default.bool,
  /** Hide Excel export option */
  hideExcel: _propTypes.default.bool,
  /** Array of format strings to hide (flexible approach) */
  hideFormats: _propTypes.default.arrayOf(_propTypes.default.string)
};
DmsExport.defaultProps = {
  url: null,
  variant: 'dark',
  needs_authentication: false,
  formats: null,
  group: true,
  title: null,
  table: null,
  hidePdf: false,
  hideCsv: false,
  hideExcel: false,
  hideFormats: []
};